"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

exports.__esModule = true;
exports.mbank = exports.mbankMatch = void 0;

var read_encoded_file_1 = require("../../util/read-encoded-file");

var papaparse_1 = require("../../util/papaparse");

var FILE_ENCODING = 'msee';
var AMOUNT_CLEANUP_REGEXP = /[-PLN\s]/g;
var SHEET_CLEANUP_REGEXP = /\s{3,}/g;
var REQUIRED_FIELDS = ['#Data operacji', '#Kwota', '#Opis operacji'];
var PARSER_SETTINGS = {
  header: true,
  delimiter: ';',
  quoteChar: "'"
};

var cleanup = function cleanup(input) {
  return input.replace(SHEET_CLEANUP_REGEXP, '').trim();
};

var trimMetaData = function trimMetaData(input) {
  return input.substr(input.indexOf('#Data operacji;'));
};

exports.mbankMatch = function (file) {
  return __awaiter(void 0, void 0, void 0, function () {
    var fileString, data, keys_1, missingKeys, e_1;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4
          /*yield*/
          , read_encoded_file_1.readEncodedFile(file, FILE_ENCODING)];

        case 1:
          fileString = _a.sent();

          if (fileString.startsWith('mBank S.A.')) {
            return [2
            /*return*/
            , true];
          }

          _a.label = 2;

        case 2:
          _a.trys.push([2, 4,, 5]);

          return [4
          /*yield*/
          , papaparse_1.parse(trimMetaData(fileString), PARSER_SETTINGS)];

        case 3:
          data = _a.sent().data;

          if (data.length === 0) {
            return [2
            /*return*/
            , false];
          }

          keys_1 = Object.keys(data[0]);
          missingKeys = REQUIRED_FIELDS.filter(function (k) {
            return !keys_1.includes(k);
          });

          if (missingKeys.length === 0) {
            return [2
            /*return*/
            , true];
          }

          return [3
          /*break*/
          , 5];

        case 4:
          e_1 = _a.sent();
          return [2
          /*return*/
          , false];

        case 5:
          return [2
          /*return*/
          , false];
      }
    });
  });
};

var mbankParser = function mbankParser(file) {
  return __awaiter(void 0, void 0, void 0, function () {
    var fileString, _a, _b, data, result;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = cleanup;
          _b = trimMetaData;
          return [4
          /*yield*/
          , read_encoded_file_1.readEncodedFile(file, FILE_ENCODING)];

        case 1:
          fileString = _a.apply(void 0, [_b.apply(void 0, [_c.sent()])]);
          return [4
          /*yield*/
          , papaparse_1.parse(fileString, PARSER_SETTINGS)];

        case 2:
          data = _c.sent().data;
          result = data;
          return [2
          /*return*/
          , [{
            data: result.filter(function (item) {
              return REQUIRED_FIELDS.every(function (key) {
                return typeof item[key] !== 'undefined';
              });
            }).map(function (item) {
              var _a = item['#Data operacji'].split('-'),
                  YYYY = _a[0],
                  MM = _a[1],
                  DD = _a[2];

              var isOutflow = item['#Kwota'].startsWith('-');
              var amount = item['#Kwota'].replace(AMOUNT_CLEANUP_REGEXP, '').replace(',', '.');
              return {
                Memo: item['#Opis operacji'],
                Date: [MM, DD, YYYY].join('/'),
                Payee: undefined,
                Outflow: isOutflow ? amount : undefined,
                Inflow: !isOutflow ? amount : undefined
              };
            })
          }]];
      }
    });
  });
};

exports.mbank = {
  name: 'mBank',
  country: 'pl',
  fileExtension: 'csv',
  filenamePattern: /^operations(_\d{6,}){3}\.csv$/,
  link: 'https://www.mbank.pl/',
  match: exports.mbankMatch,
  parse: mbankParser
};